import React, { useRef, useState } from "react";
import { CustomButton } from "../../components/CustomButton";
import { Toast } from "primereact/toast";

const CopyInput = ({ value = "" }) => {
  const [copied, setCopied] = useState(false);
  const toast = useRef(null);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.current.show({
        severity: "success",
        summary: "Copied to clipboard",
        life: 1500,
      });
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  return (
    <div className="flex items-center gap-2 w-full my-2">
      <Toast ref={toast} />
      <input
        type="text"
        value={value}
        readOnly
        className="flex-1 px-3 py-2 border rounded-lg text-sm focus:outline-none"
      />

      <CustomButton
        onClick={handleCopy}
        varient="text"
        // No label, only icon
        label={null}
        icon={
          copied ? (
            // ✓ Copied icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            // 📄 Copy icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-indigo-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
          )
        }
      />
    </div>
  );
};

export default CopyInput;
